import React from 'react'

/**
 * FOOTER COMPONENT
 * @param {{ previousStep: () => void, nextStep: () => void, totalSteps: number, currentStep: number, disabled?: boolean }} props 
 * @returns {JSX.Element}
 */
function Footer({ previousStep, nextStep, totalSteps, currentStep, disabled = false }) {

  const isEndQuiz = currentStep === totalSteps
  const isStartQuiz = disabled ? false : currentStep === 1

  return (
    <footer className="flex items-center justify-between w-full px-5 space-x-2 py-4 mb-4 mt-4">
        {!isStartQuiz ? <button type='button' title='Précédent' onClick={previousStep} className="secondary-btn px-4 w-full py-3" >
          <span>PRECEDENT</span>
          <PreviousIcon className="hidden" />
        </button> : <div></div>}
        <button type='submit' title={disabled ? '' : isEndQuiz ? 'Envoyer' : 'Suivant'}   className="px-4 py-3 w-full primary-btn">
          <span>{isEndQuiz ? 'ENVOYER' : 'SUIVANT'}</span>
          {isEndQuiz ? <SendIcon className="hidden" /> : <NextIcon className="hidden" />}
        </button>
    </footer>
  )
}


function PreviousIcon(props) {
  return (
    <svg width="2em" height="2em" {...props} viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192s192-86 192-192Z"></path></svg>
  )
}


function NextIcon(props) {
  return (
    <svg width="2em" height="2em" {...props} viewBox="0 0 32 32"><path fill="currentColor" d="m16 8l-1.43 1.393L20.15 15H8v2h12.15l-5.58 5.573L16 24l8-8l-8-8z"></path><path fill="currentColor" d="M16 30a14 14 0 1 1 14-14a14.016 14.016 0 0 1-14 14Zm0-26a12 12 0 1 0 12 12A12.014 12.014 0 0 0 16 4Z"></path></svg>
  )
}

function SendIcon(props) {
  return (
    <svg width="2em" height="2em" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="m2.721 2.051l15.355 7.566a.5.5 0 0 1 0 .897L2.72 18.08a.5.5 0 0 1-.704-.576l1.521-5.745a.5.5 0 0 1 .401-.365l6.881-1.147a.25.25 0 0 0 .188-.146l.018-.06a.25.25 0 0 0-.15-.272l-.056-.016L3.9 8.6a.5.5 0 0 1-.4-.365L2.016 2.628a.5.5 0 0 1 .704-.577Z"></path></svg>
  )
}

export default Footer